import React, {useState} from 'react';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { STRIPE_PUBLISHABLE_KEY, API_BASE, SUCCESS_URL, CANCEL_URL } from '../config';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';
import Box from '@mui/material/Box';
export default function Subscribe(){
  const [email, setEmail] = useState('');
  const [priceId, setPriceId] = useState('pro_month');
  const [loading, setLoading] = useState(false);
  async function handleSubscribe(e){
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE}/billing/create_checkout_session`, {
        price_id: priceId,
        customer_email: email,
        success_url: SUCCESS_URL,
        cancel_url: CANCEL_URL
      });
      if (res.data && res.data.sessionId) {
        const stripe = await loadStripe(STRIPE_PUBLISHABLE_KEY);
        await stripe.redirectToCheckout({ sessionId: res.data.sessionId });
      } else {
        alert('Checkout session failed: ' + JSON.stringify(res.data));
      }
    } catch (err) {
      console.error(err);
      alert('Payment initiation failed: ' + (err?.response?.data?.error || err.message));
    } finally { setLoading(false); }
  }
  return (
    <Container sx={{py:4}} maxWidth="sm">
      <Typography variant="h5" gutterBottom>Subscribe</Typography>
      <Box component="form" onSubmit={handleSubscribe} sx={{mt:2}}>
        <TextField label="Email" type="email" value={email} onChange={e=>setEmail(e.target.value)} fullWidth required />
        <Button type="submit" variant="contained" sx={{mt:2}} disabled={loading}>Pay & Subscribe</Button>
      </Box>
    </Container>
  );
}
